(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})
        ({key: "AIzaSyBa7RduvZalI-WT9KoFIgUSPK03z-YvCHQ", v: "weekly"});

let map;
let initialBounds = null;

async function initMap() {
  const { Map, InfoWindow } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

  // Clear existing map if it exists
  if (map) {
    map = null;
  }

  const mapElement = document.getElementById('map');
  if (!mapElement) {
    return;
  }

  const featuredLocationIds = mapElement.dataset.featuredLocationIds
    ? mapElement.dataset.featuredLocationIds.split(',').map((id) => id.trim()).filter(Boolean)
    : [];
  const featuredLocationSet = new Set(featuredLocationIds);

  map = new Map(mapElement, {
    mapId: '721ca767ce82fdf7',
    mapTypeControl: false,
    scrollwheel: false,
    streetViewControl: false,
    zoom: 8,
  });

  var bounds = new google.maps.LatLngBounds();
  const locations = document.querySelectorAll('.view-locations .location');
  const infoWindow = new InfoWindow();

  // Calculate bounds from all locations
  locations.forEach(function(location) {
    var thisLatLng = {
      lat: parseFloat(location.dataset.lat),
      lng: parseFloat(location.dataset.lon)
    };
    bounds.extend(thisLatLng);
  });

  // Store initial bounds if this is the first load
  if (!initialBounds && locations.length > 0) {
    initialBounds = bounds;
  }

  // Check if we have any locations
  if (locations.length === 0) {
    // Use the stored initial bounds if available
    if (initialBounds) {
      map.fitBounds(initialBounds);
    }
    return;
  }

  // If we have locations, proceed with normal mapping
  locations.forEach(function(location) {
    var url = location.dataset.url;
    var locationId = location.dataset.locationId;
    var thisLatLng = {
      lat: parseFloat(location.dataset.lat),
      lng: parseFloat(location.dataset.lon)
    };

    const isFeatured = locationId && featuredLocationSet.has(locationId);

    const pin = new PinElement({
      background: isFeatured ? "#6ABF4B" : "#808080",
      borderColor: isFeatured ? "#4e8f36" : "#5c5c5c",
      glyphColor: '#ffffff',
      scale: isFeatured ? 1.2 : 1.0
    });
    const marker = new AdvancedMarkerElement({
      map,
      position: thisLatLng,
      content: pin.element,
      title: location.dataset.title,
      zIndex: isFeatured ? 1000 : undefined
    });

    marker.addListener('click', ({domEvent, latLng}) => {
      const { target } = domEvent;
      infoWindow.close();
      infoWindow.setContent('<div class="marker-title">' + marker.title + '</div><div class="marker-link"><a href="' + url + '">View Location</a></div>');
      infoWindow.open(marker.map, marker);
    });
  });

  // Apply bounds with zoom constraint
  map.fitBounds(bounds);
  
  // Add listener for bounds_changed event to enforce maximum zoom
  google.maps.event.addListenerOnce(map, 'bounds_changed', function() {
    const MAX_ZOOM = 12; // Adjust this value to your needs
    if (map.getZoom() > MAX_ZOOM) {
      map.setZoom(MAX_ZOOM);
    }
  });
}

function filterBreastLocations() {
    const filterSelect = document.querySelector('select[name="hidden_breast_filter[]"]');
    if (filterSelect) {
        // Clear existing selections
        Array.from(filterSelect.options).forEach(option => option.selected = false);
        
        // Select our specific options (48 and 50)
        Array.from(filterSelect.options).forEach(option => {
            if (['48', '50'].includes(option.value)) {
                option.selected = true;
            }
        });
        
        // Trigger the change event for Views auto-submit
        jQuery(filterSelect).trigger('change');
    }
}

function clearBreastFilter() {
    const filterSelect = document.querySelector('select[name="hidden_breast_filter[]"]');
    if (filterSelect) {
        // Clear all selections
        Array.from(filterSelect.options).forEach(option => option.selected = false);
        // Trigger the change event for Views auto-submit
        jQuery(filterSelect).trigger('change');
    }
}

(function($, Drupal, once) {
  /**
   * Use this behavior as a template for custom Javascript.
   */
  Drupal.behaviors.frcBehavior = {
    attach: function(context, settings) {
      // Remove the once() wrapper to allow multiple executions
      if (document.getElementById('map')) {
        initMap();
      }
      
      // Add view AJAX complete handler
      $(once('viewAjaxComplete', 'body')).on('view:ajaxComplete', function(event) {
        // Check if our view was updated
        if ($(event.target).find('.view-locations').length) {
          initMap();
        }
      });

      // Modified click handler to allow anchor scroll
      $(once('breastFilterLink', '.breast-filter-link', context)).on('click', function() {
        setTimeout(filterBreastLocations, 100);
      });

      // Clear breast filter when the specific visible filter changes
      $(once('visibleFilter', 'select[name="eref_node_titles"]', context)).on('change', function() {
        clearBreastFilter();
      });
    }
  }
})(jQuery, Drupal, once);
